export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceDeliveryTypeInfo: {
        deliveryTypeName: "見守り",
        deliveryType: "follow",
        deliveryPriority: "notice",
      },
      ServiceDeliveryPeriods: [
        {
          serviceDeliveryPeriodId: 1,
          serviceDeliveryPeriodUUid: "deliveryperiod001",
          deliveryFrequencyKbn: 1,
          deliveryToKbn: 2,
          deliveryPeriodDays: 30,
          deliveryStartTime: "10:00",
          deliveryEndTime: "12:00"
        }
      ]
    }
  }
}